import gql from 'graphql-tag'

export const CREATE_USER = gql`
  mutation CreateUser(
    $username: String!
    $email: String!
    $password: String!
    $role: Role
    $status: Status
  ) {
    createUser(
      data: {
        name: $username
        email: $email
        role: $role
        status: $status
        password: $password
      }
    ) {
      id
      name
      email
    }
  }
`

export const UPDATE_USER_PROFILE = gql`
  mutation UpdateUser($id: Int!, $username: String, $email: String) {
    updateUser(id: $id, data: { name: $username, email: $email }) {
      id
      name
    }
  }
`

export const UPDATE_USER = gql`
  mutation UpdateUser(
    $id: Int!
    $username: String
    $email: String
    $role: Role
    $status: Status
  ) {
    updateUser(
      id: $id
      data: { name: $username, email: $email, role: $role, status: $status }
    ) {
      id
      name
    }
  }
`

export const DELETE_USER = gql`
  mutation DeleteUser($id: Int!) {
    deleteUser(id: $id) {
      id
    }
  }
`

export const UPLOAD_DOCUMENT = gql`
  mutation UploadDocument($document: String!, $file: Upload!) {
    uploadDocument(document: $document, file: $file) {
      uid
      url
      name
      status
    }
  }
`

export const REMOVE_DOCUMENT = gql`
  mutation RemoveDocument($document: String!, $imageId: Int!) {
    removeDocument(document: $document, imageId: $imageId) {
      id
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/User.js